import { atom } from 'recoil';

// 빈 칸 에러 메세지
export const blankDefaultMsgRecoil = atom<string>({
  key: 'blankDefaultMsgRecoil',
  default: '빈 칸을 확인해 주세요.',
});

// 에러 메세지 관리
export const errorMsgRecoil = atom<string | null>({
  key: 'errorMsgRecoil',
  default: null,
});

// 컨펌 메세지 관리
export const confirmMsgRecoil = atom<string | null>({
  key: 'confirmMsgRecoil',
  default: null,
});

// 기본 모달 관리
export const modalMsgRecoil = atom<string | null>({
  key: 'modalMsgRecoil',
  default: null,
});

//공지사항 관리
export const noticeMsgRecoil = atom<string | null>({
  key: 'noticeMsgRecoil',
  default: '공지사항 입니다.',
});

// input modal state

// 방 만들기 모달 상태
export const roomMakeStateRecoil = atom<boolean>({
  key: 'roomMakeStateRecoil',
  default: false,
});

// 방 입장 모달 상태
export const roomEntranceStateRecoil = atom<boolean>({
  key: 'roomEntranceStateRecoil',
  default: false,
});

// 비밀번호 변경 모달 상태
export const passwordChangeStateRecoil = atom<boolean>({
  key: 'passwordChangeStateRecoil',
  default: false,
});

// 내 정보 변경 모달 상태
export const myInforChangeStateRecoil = atom<boolean>({
  key: 'myInforChangeStateRecoil',
  default: false,
});

// 방 상세 탕수 수정 모달 상태
export const roomWorkNumModifyStateRecoil = atom<boolean>({
  key: 'roomWorkNumModifyStateRecoil',
  default: false,
});

// 탕수 수정 모달 상태
export const workNumModifyStateRecoil = atom<boolean>({
  key: 'workNumModifyStateRecoil',
  default: false,
});

// 가탕 수정 모달 상태
export const fakeWorkNumModifyStateRecoil = atom<boolean>({
  key: 'fakeWorkNumModifyStateRecoil',
  default: false,
});

// 월별 단가 수정 모달 상태
export const monthUnitPriceModifyStateRecoil = atom<boolean>({
  key: 'monthUnitPriceModifyStateRecoil',
  default: false,
});

// 입차 추가 모달 상태
export const entranceAddStateRecoil = atom<boolean>({
  key: 'entranceAddStateRecoil',
  default: false,
});

// 순번 수정 모달 상태
export const orderModifyStateRecoil = atom<boolean>({
  key: 'orderModifyStateRecoil',
  default: false,
});

// 순번 자동 정렬 모달 상태
export const orderAutoSortStateRecoil = atom<boolean>({
  key: 'orderAutoSortStateRecoil',
  default: false,
});

// 공지사항 수정 모달 상태
export const noticeModifyStateRecoil = atom<boolean>({
  key: 'noticeModifyStateRecoil',
  default: false,
});

// 끼어들기 모달 상태
export const interruptStateRecoil = atom<boolean>({
  key: 'interruptStateRecoil',
  default: false,
});

// 라인 이동 모달 상태
export const lineMoveStateRecoil = atom<boolean>({
  key: 'lineMoveStateRecoil',
  default: false,
});

// 타설 완료 모달 상태
export const pourStateRecoil = atom<boolean>({
  key: 'pourStateRecoil',
  default: false,
});

// 타설 목록 조회 모달 상태
export const pourListStateRecoil = atom<boolean>({
  key: 'pourListStateRecoil',
  default: false,
});

// 개인정보 처리방침 모달 상태
export const privacyPolicyStateRecoil = atom<boolean>({
  key: 'privacyPolicyStateRecoil',
  default: false,
});

// 약관 동의 모달 상태
export const privacyAgreementStateRecoil = atom<boolean>({
  key: 'privacyAgreementStateRecoil',
  default: false,
});

// 입차지 수정 모달 상태
export const entrySiteModifyStateRecoil = atom<boolean>({
  key: 'entrySiteModifyStateRecoil',
  default: false,
});

// 주소 모달 상태
export const addressStateRecoil = atom<boolean>({
  key: 'addressStateRecoil',
  default: false,
});

// 현위치 모달 상태
export const currentLocationStateRecoil = atom<boolean>({
  key: 'currentLocationStateRecoil',
  default: false,
});
